import React, { useState, useEffect } from "react";
import InputElement from "../../UI/Input/InputElement.js";
import LoanAmount from "../Controls/LoanAmount.js";
import stepHandler from "../StepHandler.js";
import {
	Button,
	Box,
	Text,
	Link,
	Center,
	Container,
	Heading,
	Stack,
	Separator,
	Flex,
	Spacer,
} from "@chakra-ui/react";

const Purpose = ({
	config,
	form,
	onChanged,
	onBlurred,
	trackFields,
	jumpToStep,
	save,
	previous,
	next,
}) => {
	const [loading, setLoading] = useState(false);
	const [isContinueDisabled, setIsContinueDisabled] = useState(true);

	useEffect(() => {
		trackFields("Purpose", ["loanAmount", "loanPurpose", "leadAggregation"]);
		window.scrollTo(0, 0);
	}, [trackFields]);

	useEffect(() => {
		const { loanAmount, loanPurpose, leadAggregation } = form;

		const isLoanAmountZero = loanAmount.value.trim() === "0";
		const isLoanPurposeValid = loanPurpose.value !== "";
		const isLeadAggregationValid = leadAggregation.value !== "";

		setIsContinueDisabled(
			isLoanAmountZero || !isLoanPurposeValid || !isLeadAggregationValid,
		);
	}, [
		form.loanAmount.value,
		form.loanPurpose.value,
		form.leadAggregation.value,
	]);

	return (
		<>
			<Container maxW="600px" mt={10}>
				<Center>
					<Heading mb={14} style={{ fontSize: "15px", fontWeight: "bold" }}>
						Tell us about your financial needs
					</Heading>
				</Center>
			</Container>

			<Center>
				<Stack spacing="10px">
					<Box maxW="250px" mt={5}>
						<Text fontWeight="semibold" fontSize="14px">
							How much would you like to borrow?
						</Text>

						<LoanAmount
							stateConfig={config}
							formElement={form.loanAmount}
							changeHandler={onChanged}
							blurHandler={onBlurred}
						/>
					</Box>

					<Box maxW="510px" bg="#F5F5F5" mt={5} p={8}>
						<Text fontSize="14px" as="b">
							Interested in borrowing more?
						</Text>
						<Text fontSize="14px">
							With an auto-secured loan, your vehicle is provided as collateral,
							which could qualify you for a larger loan amount and lower
							interest rates.
						</Text>
						<Box mt={3}>
							<Link
								onClick={() => {
									jumpToStep(2);
								}}
							>
								<Text color={"#2171A6"} as="u">
									Learn more about auto-secured loans
								</Text>
							</Link>
						</Box>
					</Box>

					<Box maxW="360px">
						<Text fontWeight={"semibold"}>
							How do you plan to use this money?
						</Text>
						<InputElement
							formElement={form.loanPurpose}
							onChange={(event) => onChanged(event, "loanPurpose")}
							onBlur={(event) => onBlurred(event, "loanPurpose")}
						/>
					</Box>

					<Box maxW="360px">
						<Text fontWeight={"semibold"}>How did you hear about us?</Text>
						<InputElement
							formElement={form.leadAggregation}
							onChange={(event) => onChanged(event, "leadAggregation")}
							onBlur={(event) => onBlurred(event, "leadAggregation")}
						/>
					</Box>
				</Stack>
			</Center>

			<Center>
				<Box mt={10} maxW="510px" w="100%" borderTop="1px solid #ccc" />
			</Center>

			<Container maxW="510px" mb={10}>
				<Flex>
					<Button
						id="back-button"
						onClick={() => {
							save();
							previous();
						}}
						bg="white"
						color="#2371a5"
						_hover={{ bg: "#3c99d3", color: "white" }}
						size="lg"
						mt={10}
						p={4}
						border="1px solid #2371a5"
						borderRadius="6px"
					>
						Back
					</Button>
					<Spacer />
					<Button
						onClick={() => {
							if (!isContinueDisabled) {
								save();
								next();
								setLoading(true);
							}
						}}
						id="next-button"
						bg="#2371a5"
						color="white"
						_hover={{ bg: "#3c99d3" }}
						size="lg"
						mt={10}
						p={4}
						minW="50px"
						isLoading={loading}
						loadingText="Continue"
						disabled={isContinueDisabled}
						borderRadius="6px"
					>
						Continue
					</Button>
				</Flex>
			</Container>
		</>
	);
};

export default stepHandler(Purpose);
